import './App.css';
import MembershipGateway from './ui/MembershipGateway';

function App() {
  return <MembershipGateway />;
}

export default App;